(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["find-in-store"] && !Shopify.designMode) return;
  try {
    class FindInStoreTrigger extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-find-in-store-trigger]');
      if (!this.btn) return;

      var dataEl = this.querySelector('[data-find-in-store-skus]');
      try {
        this.skus = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.skus = {};
      }

      this._onVariant = this._onVariant.bind(this);
      document.addEventListener('variant:change', this._onVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariant);
    }

    _onVariant(event) {
      if (!event.detail || event.detail.variantId == null) return;
      var sku = this.skus[String(event.detail.variantId)];
      if (sku != null && this.btn) this.btn.setAttribute('data-sku', sku);
    }
  }

  if (!window.customElements.get('find-in-store-trigger')) {
    window.customElements.define('find-in-store-trigger', FindInStoreTrigger);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-details"] && !Shopify.designMode) return;
  try {
    /*
    Accordion open/close (#267). Animates explicit pixel heights on the <details> element
    with the Web Animations API so every engine animates: the CSS `::details-content` +
    `interpolate-size` transition this replaces only ran in Chromium. Safari (69% of
    sessions) and Firefox have no `interpolate-size`, so 0 <-> auto snapped in one frame
    and, because the open Description above collapsed instantly, the row the user tapped
    leapt off the top of the viewport. Live (Radix) animates measured heights over 250ms
    ease-out; this does the same, and covers Safari < 18.4 (no ::details-content) too.

    One-open-at-a-time: the markup keeps the shared `name` as the no-JS path, but a native
    exclusive group drops the sibling's `open` synchronously, leaving nothing to animate.
    On the first tap the group's `name` is removed and exclusivity is orchestrated here:
    the open sibling collapses while the tapped item expands, both over the same 250ms.
  */
  (function () {
    var DURATION = 250;
    var EASING = 'ease-out';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function rectHeight(el) {
      return el.getBoundingClientRect().height;
    }

    // Collapsed height: the summary row plus the item's own borders (box-sizing is
    // border-box globally, so the animated `height` is the full outer height).
    function collapsedHeight(item) {
      var summary = item.querySelector('summary');
      return (summary ? rectHeight(summary) : 0) + (item.offsetHeight - item.clientHeight);
    }

    function cancelAnimation(item) {
      if (item._pdAnimation) {
        item._pdAnimation.cancel();
        item._pdAnimation = null;
      }
    }

    function animateHeight(item, from, to, onFinish) {
      item.setAttribute('data-animating', '');
      var animation = item.animate([{ height: from + 'px' }, { height: to + 'px' }], {
        duration: DURATION,
        easing: EASING,
      });
      item._pdAnimation = animation;
      animation.onfinish = function () {
        // A newer animation may have superseded this one (rapid taps); it owns the cleanup.
        if (item._pdAnimation !== animation) return;
        item._pdAnimation = null;
        item.removeAttribute('data-animating');
        if (onFinish) onFinish();
      };
    }

    function openItem(item) {
      var from = rectHeight(item);
      cancelAnimation(item);
      item.removeAttribute('data-closing');
      item.open = true;
      if (reduceMotion.matches) return;
      animateHeight(item, from, rectHeight(item));
    }

    function closeItem(item) {
      var from = rectHeight(item);
      cancelAnimation(item);
      if (reduceMotion.matches) {
        item.open = false;
        return;
      }
      item.setAttribute('data-closing', '');
      animateHeight(item, from, collapsedHeight(item), function () {
        item.open = false;
        item.removeAttribute('data-closing');
      });
    }

    document.addEventListener('click', function (event) {
      var summary = event.target.closest('.product-details__summary');
      if (!summary) return;
      var item = summary.parentElement;
      if (!item || item.tagName !== 'DETAILS' || typeof item.animate !== 'function') return;
      event.preventDefault();

      var group = item.closest('.product-details__items');
      var items = group ? group.querySelectorAll('.product-details__item') : [item];
      for (var i = 0; i < items.length; i++) {
        items[i].removeAttribute('name');
      }

      var isClosing = item.hasAttribute('data-closing');
      if (item.open && !isClosing) {
        closeItem(item);
        return;
      }
      for (var j = 0; j < items.length; j++) {
        if (items[j] !== item && items[j].open && !items[j].hasAttribute('data-closing')) {
          closeItem(items[j]);
        }
      }
      openItem(item);
    });
  })();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-reviews-scroll]');
    if (!trigger) return;
    var target = document.getElementById('reviews-section');
    if (!target) return;
    event.preventDefault();
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-footnotes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-afterpay')) {
    customElements.define(
      'product-afterpay',
      class extends HTMLElement {
        connectedCallback() {
          this._onChange = this._onChange.bind(this);
          document.addEventListener('variant:change', this._onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('variant:change', this._onChange);
        }

        _onChange(event) {
          var id = event && event.detail && event.detail.variantId;
          if (id == null) return;
          var match = this.querySelector('[data-afterpay-variant][data-variant-id="' + id + '"]');
          if (!match) return;
          var nodes = this.querySelectorAll('[data-afterpay-variant]');
          for (var i = 0; i < nodes.length; i++) {
            nodes[i].hidden = true;
          }
          match.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id-input]');
      this.addBtn = this.querySelector('.product-form__add');
      this.addWrap = this.querySelector('[data-add-wrap]');
      this.notifyBtn = this.querySelector('.product-form__notify');
      this.notifyWrap = this.querySelector('[data-notify-wrap]');
      this.errorEl = this.querySelector('.product-form__error');
      this.statusEl = this.querySelector('[data-form-status]');
      this.upcoming = this.dataset.upcoming === 'true';

      var dataEl = this.querySelector('[data-product-form-data]');
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.data = { variants: {} };
      }

      this._onVariant = this._onVariant.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      document.addEventListener('variant:change', this._onVariant);
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      // Gift mode: a gift-card-form on the page (product.giftcards template) switches
      // the CTA to validity-gating and the line-item props to the gifting fields.
      this.giftForm = document.querySelector('gift-card-form');
      if (this.giftForm) {
        this.classList.add('product-form--gift');
        this._giftValid = !!this.giftForm.valid;
        this._onGiftChange = this._onGiftChange.bind(this);
        document.addEventListener('gift-form:change', this._onGiftChange);
      }

      this.currentId = this.idInput ? this.idInput.value : '';
      this._sync(this.currentId);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariant);
      if (this._onGiftChange) document.removeEventListener('gift-form:change', this._onGiftChange);
      if (this.form) this.form.removeEventListener('submit', this._onSubmit);
    }

    _onGiftChange(event) {
      this._giftValid = !!(event.detail && event.detail.valid);
      this._sync(this.currentId);
    }

    _onVariant(event) {
      if (!event.detail || event.detail.variantId == null) return;
      this._sync(String(event.detail.variantId));
    }

    _sync(variantId) {
      this.currentId = variantId;
      if (this.idInput) this.idInput.value = variantId;
      if (this.notifyBtn) this.notifyBtn.setAttribute('data-variant-id', variantId);
      var variant = this.data.variants[variantId];
      var available = variant ? variant.available : false;

      // Gift mode: never swap to notify-me. The CTA is validity-gated instead, and an
      // unavailable selection (all denominations sold out) shows the sold-out label.
      if (this.giftForm) {
        if (this.addWrap) this.addWrap.hidden = false;
        if (this.notifyWrap) this.notifyWrap.hidden = true;
        if (this.addBtn) {
          this.addBtn.disabled = !this._giftValid || !available;
          if (!this.addBtn.getAttribute('aria-busy') || this.addBtn.getAttribute('aria-busy') === 'false') {
            this.addBtn.textContent = available ? this.dataset.labelAdd || '' : this.dataset.labelSoldout || '';
          }
        }
        return;
      }

      var showNotify = this.upcoming || !available;
      if (this.addWrap) this.addWrap.hidden = showNotify;
      if (this.notifyWrap) this.notifyWrap.hidden = !showNotify;
    }

    _onSubmit(event) {
      event.preventDefault();
      if (this.upcoming && !this.giftForm) return;
      var variant = this.data.variants[this.currentId];
      if (!variant || !variant.available) return;
      if (this.giftForm && !this._giftValid) return;

      this._clearError();
      this._setBusy(true);

      var props;
      if (this.giftForm) {
        // Gift lines carry the gifting fields only (live parity: _aux_* attrs are
        // standard-form-only).
        props = Object.assign({}, this.giftForm.properties);
        // Hidden marker for the checkout pixel (#190): Web Pixels expose no
        // gift-card flag and these products have a blank type, so purchase
        // revenue can only exclude gift cards if the line says it is one.
        props._aux_gift_card = '1';
      } else {
        // Hidden _aux_* props for the checkout pixel from the PDP analytics
        // payload (#335, #336). No dcAnalytics (theme editor, blocked script):
        // the add goes ahead without them.
        var dca = window.dcAnalytics;
        props = dca && dca.lineProps ? dca.lineProps(dca.productPayload(), variant.size) : {};
      }
      Object.keys(props).forEach(function (key) {
        if (props[key] === '' || props[key] == null) delete props[key];
      });

      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(this.currentId), quantity: 1, properties: props }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (response.ok) {
            return response.json().then(function (json) {
              self._onAdded(json);
            });
          }
          // Shopify's cart error body carries the reason ("… is already sold
          // out" for a size this market cannot ship); surface it rather than
          // the generic label (#301).
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (body) {
              var message = body && (body.description || body.message);
              self._onError(typeof message === 'string' ? message : '');
            });
        })
        .catch(function () {
          self._onError();
        })
        .finally(function () {
          self._setBusy(false);
        });
    }

    _onAdded(json) {
      // The <cart-drawer> controller owns the drawer swap, added-mode, open,
      // auto-close and header-count sync -- this block only announces the add.
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: {
            variantId: Number(this.currentId),
            quantity: 1,
            sections: (json && json.sections) || null
          }
        })
      );

      if (this.statusEl) this.statusEl.textContent = this.dataset.labelAdded || '';
    }

    _onError(message) {
      var text = message || this.dataset.labelError || '';
      if (this.errorEl) {
        this.errorEl.textContent = text;
        this.errorEl.hidden = false;
      }
      if (this.statusEl) this.statusEl.textContent = text;
    }

    _clearError() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    _setBusy(on) {
      if (!this.addBtn) return;
      this.addBtn.disabled = on;
      this.addBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) {
        // Live shows a spinner (not "Adding..." text). Keep the label as the accessible name.
        this.addBtn.setAttribute('aria-label', this.dataset.labelAdding || '');
        this.addBtn.innerHTML = '<span class="product-form__spinner" aria-hidden="true"></span>';
      } else {
        this.addBtn.removeAttribute('aria-label');
        this.addBtn.textContent = this.dataset.labelAdd || '';
      }
    }
  }

  if (!window.customElements.get('product-form')) {
    window.customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gift-card-form"] && !Shopify.designMode) return;
  try {
    class GiftCardForm extends HTMLElement {
    connectedCallback() {
      // Live validation rules, ported verbatim from ProductGiftCardForm.tsx. The
      // allowlist includes the en dash (u2013) and curly quotes (u2018/u2019,
      // u201C/u201D), written as escapes so no exotic bytes reach the bundler.
      this.SPECIAL_CHARS =
        /^[a-zA-Z0-9 `~!@#$%^&*()\u2013\-_=+\[\]{}\\\/;:\u2018\u2019\u201C\u201D"',.<>|?\r\n]+$/;
      this.EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      this.select = this.querySelector('[data-gift-amount]');
      this.counter = this.querySelector('[data-gift-counter]');
      this.controls = {};
      var self = this;
      this.querySelectorAll('[data-form-field-control]').forEach(function (control) {
        if (control.name) self.controls[control.name] = control;
      });
      this.required = ['from', 'to', 'message'];
      if (this.controls.email) this.required.push('email', 'email_confirmation');

      this._onInput = this._onInput.bind(this);
      this._onSelect = this._onSelect.bind(this);
      this.addEventListener('input', this._onInput);
      if (this.select) this.select.addEventListener('change', this._onSelect);

      this._validate();
    }

    disconnectedCallback() {
      this.removeEventListener('input', this._onInput);
      if (this.select) this.select.removeEventListener('change', this._onSelect);
    }

    get valid() {
      return !!this._valid;
    }

    // Cart line-item properties. Keys AND insertion order match the live payload
    // (#146 renders them in posted order): From / To / Message / Email / Delivery
    // Date -- Message before Email, mirroring the live form state. The email
    // confirmation field and empty values are never submitted.
    get properties() {
      var props = {};
      var value = this._value.bind(this);
      if (value('from')) props['From'] = value('from');
      if (value('to')) props['To'] = value('to');
      if (value('message')) props['Message'] = value('message');
      if (value('email')) props['Email'] = value('email');
      if (value('date')) props['Delivery Date'] = value('date');
      return props;
    }

    _value(name) {
      return this.controls[name] ? this.controls[name].value : '';
    }

    _onSelect() {
      if (this.select.value) {
        document.dispatchEvent(
          new CustomEvent('variant:change', { detail: { variantId: Number(this.select.value) } })
        );
      }
      this._validate();
    }

    _onInput(event) {
      if (this.counter && event.target === this.controls.message) this._updateCounter();
      this._validate();
    }

    _updateCounter() {
      var max = Number(this.counter.getAttribute('data-max')) || 0;
      var remaining = max - this.controls.message.value.length;
      var template =
        remaining === 1
          ? this.counter.getAttribute('data-template-singular')
          : this.counter.getAttribute('data-template-plural');
      this.counter.textContent = (template || '%d').replace('%d', remaining);
    }

    _setError(control, message) {
      var field = control.closest('[data-form-field]');
      var slot = field && field.querySelector('[data-field-error]');
      if (slot) slot.textContent = message || '';
      if (message) {
        control.setAttribute('aria-invalid', 'true');
      } else {
        control.removeAttribute('aria-invalid');
      }
    }

    _validate() {
      var failures = false;
      var self = this;

      ['from', 'to', 'message'].forEach(function (name) {
        var control = self.controls[name];
        if (!control) return;
        var bad = control.value.length > 0 && !self.SPECIAL_CHARS.test(control.value);
        self._setError(control, bad ? self.dataset.errorSpecial : '');
        if (bad) failures = true;
      });

      var email = this.controls.email;
      var confirmation = this.controls.email_confirmation;
      if (email) {
        var emailBad = email.value.length > 0 && !this.EMAIL.test(email.value);
        this._setError(email, emailBad ? this.dataset.errorEmail : '');
        if (emailBad) failures = true;
      }
      if (confirmation) {
        var message = '';
        if (confirmation.value.length > 0 && !this.EMAIL.test(confirmation.value)) {
          message = this.dataset.errorEmail;
        } else if (confirmation.value.length > 0 && email && confirmation.value !== email.value) {
          message = this.dataset.errorMismatch;
        }
        this._setError(confirmation, message);
        if (message) failures = true;
      }

      var date = this.controls.date;
      if (date && date.value && date.validity && !date.validity.valid) failures = true;

      var filled = this.required.every(function (name) {
        return self.controls[name] && self.controls[name].value.length > 0;
      });

      var amountChosen = !this.select || !!this.select.value;

      this._valid = filled && amountChosen && !failures;
      document.dispatchEvent(new CustomEvent('gift-form:change', { detail: { valid: this._valid } }));
    }
  }

  if (!window.customElements.get('gift-card-form')) {
    window.customElements.define('gift-card-form', GiftCardForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-price')) {
    customElements.define(
      'product-price',
      class extends HTMLElement {
        connectedCallback() {
          this._onChange = this._onChange.bind(this);
          document.addEventListener('variant:change', this._onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('variant:change', this._onChange);
        }

        _onChange(event) {
          var id = event && event.detail && event.detail.variantId;
          if (id == null) return;
          var match = this.querySelector('[data-variant-price][data-variant-id="' + id + '"]');
          if (!match) return;
          var nodes = this.querySelectorAll('[data-variant-price]');
          for (var i = 0; i < nodes.length; i++) {
            nodes[i].hidden = true;
          }
          match.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-variant-picker')) {
    customElements.define(
      'product-variant-picker',
      class extends HTMLElement {
        connectedCallback() {
          this._onChange = this._onChange.bind(this);
          this.addEventListener('change', this._onChange);
          this._note = this.querySelector('[data-low-stock-note]');
          this._live = this.querySelector('[data-low-stock-live]');
          this._lowText = this._note ? this._note.textContent.trim() : '';
          var checked = this.querySelector('input[type="radio"]:checked');
          if (checked) this._syncUrl(checked.dataset.variantId);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this._onChange);
        }

        _onChange(event) {
          var input = event.target;
          if (!input || input.type !== 'radio') return;
          var variantId = Number(input.dataset.variantId);
          if (!variantId) return;
          document.dispatchEvent(
            new CustomEvent('variant:change', { detail: { variantId: variantId } })
          );
          var low = input.dataset.lowStock === 'true';
          if (this._note) this._note.hidden = !low;
          if (this._live) this._live.textContent = low ? this._lowText : '';
          this._syncUrl(input.dataset.variantId);
        }

        _syncUrl(id) {
          if (!id) return;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
